const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgError = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 201.3 214.9",
    style: {
      enableBackground: "new 0 0 201.3 214.9"
    },
    xmlSpace: "preserve",
    width: 280,
    height: 299,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 7.2944,
    cy: 313.0267,
    r: 17.7118,
    gradientTransform: "matrix(0.9833 -0.1821 0.1821 0.9833 -2.0424 -235.3055)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#594539",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 7.2944,
    cy: 313.0267,
    r: 17.7118,
    gradientTransform: "matrix(0.9833 -0.1821 0.1821 0.9833 -2.0424 -235.3055)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#594539",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.6343,
    y1: 120.4171,
    x2: 76.2895,
    y2: 127.4744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BF8F68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8456,
    style: {
      stopColor: "#DBB48E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0BB95"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.685,
    y1: 212.3989,
    x2: 46.7386,
    y2: 141.6375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0069,
    style: {
      stopColor: "#4B4C75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2647,
    style: {
      stopColor: "#646593"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5499,
    style: {
      stopColor: "#797AAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8042,
    style: {
      stopColor: "#8687BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B8CC4"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.8527,
    y1: 214.9102,
    x2: 101.4032,
    y2: 167.779
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0069,
    style: {
      stopColor: "#4B4C75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    style: {
      stopColor: "#5A5B88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5198,
    style: {
      stopColor: "#7576A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8068,
    style: {
      stopColor: "#8586BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B8CC4"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 68.4961,
    cy: 109.9991,
    r: 9.2021,
    gradientTransform: "matrix(-0.8881 0.4596 -0.3152 -0.609 163.9995 145.5106)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BF8F68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1704,
    style: {
      stopColor: "#C69972"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6886,
    style: {
      stopColor: "#D9B28B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0BB95"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 69.444,
    cy: 82.6582,
    r: 17.1674,
    gradientTransform: "matrix(1 0 0 1 0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#594539",
      stopOpacity: 0
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {},
    points: "47.1968,189.3293 44.4448,195.1084 40.5124,188.6824 ",
    fill: "#8B8CC4"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 100.65,
    cy: 107.45,
    r: 100.8,
    fill: "#E1DFDD"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 151.795,
    cy: 73.8101,
    r: 29.2846,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 122.5805,
    cy: 89.1316,
    r: 6.6944,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 109.6048,
    cy: 92.1287,
    r: 3.5503,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M151.8371,87.556c-0.7601,0.0138-1.493-0.2819-2.0307-0.8193       c-0.5554-0.5324-0.8584-1.2758-0.8333-2.0447c-0.0198-0.768,0.2823-1.5093,0.8333-2.0447c0.8226-0.7986,2.0386-1.0374,3.1021-0.6092       c0.3384,0.1391,0.6472,0.341,0.9103,0.5952c0.2702,0.2601,0.4888,0.569,0.6442,0.9103c0.1616,0.361,0.2428,0.7529,0.2381,1.1484       c0.0031,0.3863-0.0782,0.7687-0.2381,1.1204c-0.155,0.3416-0.3737,0.6505-0.6442,0.9103c-0.2632,0.2541-0.572,0.456-0.9103,0.5952       C152.5705,87.4672,152.2064,87.5481,151.8371,87.556z M151.788,78.7959L151.788,78.7959c-1.2956,0-2.3571-1.0287-2.3978-2.3237       l-0.4375-13.9267c-0.0425-1.3538,1.0434-2.4743,2.3978-2.4743h0.875c1.3544,0,2.4404,1.1206,2.3978,2.4743l-0.4375,13.9267       C154.1452,77.7672,153.0836,78.7959,151.788,78.7959z",
    fill: "#F7B548"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M56.6481,132.2697h29.2035c7.7061,0,14.713,2.98,19.9427,7.8449       c-8.26-8.9573-20.0898-14.5726-33.235-14.5726h-0.0001c-10.0646,0-19.358,3.2928-26.8699,8.8549       C49.0755,133.0295,52.7721,132.2697,56.6481,132.2697z",
    fill: "#E0BB95"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M84.4461,65.2191l-44.6845,8.2756l-3.951-1.149l3.2624-2.6692l44.6845-8.2756       c0.7757-0.1436,1.5279,0.3735,1.6716,1.1492l0.1662,0.9975C85.7389,64.3233,85.2218,65.0754,84.4461,65.2191z",
    fill: "#F7B548"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {},
    cx: 60.3125,
    cy: 62.8642,
    rx: 14.5626,
    ry: 14.5626,
    fill: "#594539"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 7.2944,
    cy: 313.0267,
    r: 17.7118,
    gradientTransform: "matrix(0.9833 -0.1821 0.1821 0.9833 -2.0424 -235.3055)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#594539",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 60.3098,
    cy: 62.8813,
    r: 14.562,
    fill: "url(\"#SVGID_1_\")"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {},
    cx: 66.3207,
    cy: 93.8636,
    rx: 28.5743,
    ry: 28.5743,
    fill: "#594539"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M84.3511,127.0965l-3.2989-0.6606c-1.4418-0.2887-2.4795-1.5548-2.4795-3.0252v-2.0147       l-1.9321,5.6788L84.3511,127.0965z",
    fill: "#E0BB95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.6343,
    y1: 120.4171,
    x2: 76.2895,
    y2: 127.4744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BF8F68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8456,
    style: {
      stopColor: "#DBB48E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0BB95"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 61.7203,
    y: 103.9171,
    style: {},
    width: 16.8525,
    height: 41.9085,
    fill: "url(\"#SVGID_2_\")"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M85.8516,132.2697H56.6481c-16.1784,0-29.2936,13.1152-29.2936,29.2936v15.0786       C45.7319,196.1023,71.7711,208.25,100.65,208.25c4.9229,0,9.761-0.3598,14.4951-1.0417v-45.645       C115.1451,145.3849,102.03,132.2697,85.8516,132.2697z",
    fill: "#FFD590"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.685,
    y1: 212.3989,
    x2: 46.7386,
    y2: 141.6375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0069,
    style: {
      stopColor: "#4B4C75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2647,
    style: {
      stopColor: "#646593"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5499,
    style: {
      stopColor: "#797AAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8042,
    style: {
      stopColor: "#8687BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B8CC4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M27.3545,149.4726l-8.024,33.6084c21.1819-5.9536,25.9023,10.1144,40.6767,16.6322v-74.8405       h-8.0529C32.5308,124.8078,27.3545,149.4726,27.3545,149.4726z",
    fill: "url(\"#SVGID_3_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.8527,
    y1: 214.9102,
    x2: 101.4032,
    y2: 167.779
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0069,
    style: {
      stopColor: "#4B4C75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    style: {
      stopColor: "#5A5B88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5198,
    style: {
      stopColor: "#7576A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8068,
    style: {
      stopColor: "#8586BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B8CC4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M86.3262,127.6781v79.5541c4.6796,0.6658,9.4603,1.0178,14.3238,1.0178       c5.8336,0,11.5494-0.5019,17.1118-1.4532v-36.2617C117.7618,150.4302,100.65,142.9571,86.3262,127.6781z",
    fill: "url(\"#SVGID_4_\")"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M86.3262,127.6781c-0.6924,8.0411,3.8672,41.5984,3.8672,41.5984s26.7113,5.7573,25.4337,16.9829       c-1.2082,10.6149-34.0579,10.3452-34.0579,10.3452l1.3116,10.0833c5.7683,1.0259,11.7061,1.5621,17.7692,1.5621       c10.1762,0,19.9977-1.514,29.2582-4.3186c2.9742-1.3699,5.4464-3.132,7.1291-5.385       C150.7305,180.2115,125.7831,140.9665,86.3262,127.6781z",
    fill: "#8B8CC4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {},
    cx: 67.3035,
    cy: 100.613,
    rx: 21.9837,
    ry: 21.9836,
    fill: "#E0BB95"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 68.4961,
    cy: 109.9991,
    r: 9.2021,
    gradientTransform: "matrix(-0.8881 0.4596 -0.3152 -0.609 163.9995 145.5106)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BF8F68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1704,
    style: {
      stopColor: "#C69972"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6886,
    style: {
      stopColor: "#D9B28B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0BB95"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {},
    points: "64.6776,87.6615 71.3066,122.229 55.19,118.6985 47.4555,90.6585 ",
    fill: "url(\"#SVGID_5_\")"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M71.012,121.1131l-1.8994-7.3302c-0.1222-0.4714-0.4125-0.8874-0.8273-1.1425       c-0.573-0.3523-1.2821-0.6906-1.5315-1.3252c-0.7385-1.8798,1.2528-2.4743,1.4463-5.3374c0.0075-0.1108-0.8081-4.1908-0.8081-4.1908       l4.7195-0.8754l5.2168,17.4145L71.012,121.1131z",
    fill: "#E0BB95"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M85.4658,101.4292c-0.4199-2.269-1.6987-4.2383-3.6001-5.5459       c-1.9023-1.3071-4.1982-1.7964-6.4678-1.3755c-2.269,0.4199-4.2383,1.6987-5.5459,3.6001       c-0.6478,0.9425-1.0932,1.9823-1.3279,3.0674l-2.4282,0.4496c-0.6154-0.9675-1.4224-1.8121-2.3957-2.4814       c-1.9019-1.3076-4.1987-1.7954-6.4678-1.3755c-4.6841,0.8677-7.7891,5.3843-6.9214,10.0684       c0.4199,2.269,1.6987,4.2378,3.6001,5.5454c1.457,1.002,3.1455,1.5225,4.8755,1.5225c0.5288,0,1.061-0.0488,1.5918-0.1465       c2.269-0.4199,4.2388-1.6992,5.5464-3.6006c1.3071-1.9014,1.7959-4.1987,1.3755-6.4678c-0.0696-0.3761-0.1712-0.7401-0.2869-1.0981       l1.3341-0.2471c0.0171,0.4099,0.053,0.8208,0.1291,1.2314c0.4199,2.2686,1.6987,4.2378,3.6001,5.5454       c1.457,1.002,3.1455,1.5225,4.876,1.5225c0.5283,0,1.0605-0.0488,1.5913-0.1465c2.269-0.4199,4.2388-1.6992,5.5464-3.6006       C85.3975,105.9951,85.8862,103.6982,85.4658,101.4292z M64.1934,109.9668c-0.9893,1.4395-2.48,2.4072-4.1973,2.7246       c-1.7188,0.3213-3.4551-0.0508-4.8945-1.041c-1.4395-0.9893-2.4067-2.4795-2.7251-4.1968       c-0.6562-3.5449,1.6938-6.9629,5.2388-7.6201c3.542-0.6562,6.9629,1.6938,7.6196,5.2388       C65.5527,106.7895,65.1831,108.5283,64.1934,109.9668z M82.3589,106.7065c-0.9893,1.439-2.48,2.4067-4.1973,2.7241       c-1.7188,0.3203-3.4551-0.0508-4.8945-1.041c-1.4395-0.9888-2.4067-2.4795-2.7251-4.1968       c-0.6562-3.5449,1.6934-6.9629,5.2388-7.6196c0.4004-0.0742,0.7998-0.1099,1.1934-0.1099c3.0889,0,5.8438,2.2041,6.4263,5.3486       C83.7183,103.5293,83.3486,105.2675,82.3589,106.7065z",
    fill: "#8B8CC4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M77.6713,71.2495c-0.2543-1.3737-0.6079-2.7012-1.0499-3.9811       c-1.2503-0.5049-10.4609-0.8316-16.1235,0.8276c-15.0753,4.4172-22.2485,31.7737-22.1237,32.2786       c5.1931,2.6997,11.2895,3.7487,17.4896,2.6005c9.6561-1.7883,17.1693-8.4705,20.4547-17.0097       C78.0668,81.4312,78.6206,76.3749,77.6713,71.2495z",
    fill: "#594539"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M77.6714,71.2496c-0.2544-1.3737-0.608-2.7012-1.0499-3.9811       c8.7276,3.5145,15.5221,11.2777,17.3621,21.2127c0.6152,3.3217,0.6251,6.6201,0.1078,9.7728       c-7.3445-1.4675-13.8062-5.9332-17.7728-12.2887C78.0668,81.4312,78.6206,76.3749,77.6714,71.2496z",
    fill: "#594539"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 69.444,
    cy: 82.6582,
    r: 17.1674,
    gradientTransform: "matrix(1 0 0 1 0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#594539",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M77.6714,71.2496c-0.2544-1.3737-0.608-2.7012-1.0499-3.9811       c8.7276,3.5145,15.5221,11.2777,17.3621,21.2127c0.6152,3.3217,0.6251,6.6201,0.1078,9.7728       c-7.3445-1.4675-13.8062-5.9332-17.7728-12.2887C78.0668,81.4312,78.6206,76.3749,77.6714,71.2496z",
    fill: "url(\"#SVGID_6_\")"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9833 -0.1821 0.1821 0.9833 -18.5718 12.535)",
    style: {},
    cx: 58.9756,
    cy: 107.4039,
    rx: 1.6176,
    ry: 2.8802,
    fill: "#594539"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9833 -0.1821 0.1821 0.9833 -17.6982 15.6009)",
    style: {},
    cx: 76.1085,
    cy: 104.1791,
    rx: 1.6176,
    ry: 2.8802,
    fill: "#594539"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M60.1806,124.8416l4.7141,4.6721c0,0-9.8728,35.6592-10.1851,35.347       c-0.3122-0.3122-13.3421-5.0449-13.3421-5.0449L60.1806,124.8416z",
    fill: "#E0BB95"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M64.9028,129.5115l-13.805-5.1658l-3.3636-10.2385l0,0c0.5996-0.3361,1.339-0.2978,1.9037,0.094       c0.7549,0.5235,1.3781,1.2244,1.8104,2.0481l2.3751,4.5253l5.8432,0.7429c1.4942,0.19,2.7585,0.6718,3.8509,1.4709       c1.2008,0.8784,1.8252,2.3465,1.6694,3.8261L64.9028,129.5115z",
    fill: "#E0BB95"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M73.3344,116.0765l-1.359,0.5917c-0.4211,0.192-0.865,0.3657-1.371,0.5212         c-0.5034,0.1517-1.0718,0.2786-1.6903,0.2757c-0.6103,0.0088-1.2782-0.1054-1.8386-0.4822         c-0.2297-0.1544-0.2908-0.4659-0.1363-0.6956c0.0432-0.0642,0.0986-0.1152,0.1611-0.1521l0.0412-0.0239         c0.5094-0.2975,0.9176-0.5154,1.3562-0.7192c0.4324-0.2139,0.8903-0.3995,1.4138-0.5511c0.5207-0.1473,1.1099-0.2687,1.7487-0.2393         c0.6304,0.0168,1.3162,0.1845,1.8393,0.6164c0.2114,0.1745,0.2413,0.4874,0.0667,0.6988c-0.051,0.0618-0.1138,0.108-0.1824,0.1382         L73.3344,116.0765z",
    fill: "#BF8F68"
  })), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M201.45,107.45c0,55.6703-45.1297,100.8-100.8,100.8c-28.7816,0-54.7459-12.0628-73.1129-31.4084       c-1.3119-1.3818-8.7407,13.147-9.9733,11.6926c-1.2327-1.4544,3.7308-18.8921,2.5809-20.4156       C7.4045,151.2395-0.15,130.227-0.15,107.45c0-55.6703,45.1297-100.8,100.8-100.8S201.45,51.7797,201.45,107.45z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M65.3782,136.6627c0,0-19.3983,56.5641-21.3291,59.1865         c-2.7869,3.785-12.4465,7.6301-19.3708,3.3068c-8.5097-5.3131-6.8754-16.934-1.9101-22.7222         c13.7704-16.0526,32.6875-45.4432,32.6875-45.4432L65.3782,136.6627z",
    fill: "#8B8CC4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797673"
    },
    d: "M107.2004,160.821H48.873c-1.5911,0-2.8811,1.3546-2.8811,3.0256v28.3074       c14.4329,9.3326,31.4012,15.078,49.6461,15.9715h10.0242c0.7958-0.039,1.5886-0.0891,2.3795-0.1464       c1.1779-0.3798,2.04-1.5176,2.04-2.8792v-41.2534C110.0815,162.1756,108.7916,160.821,107.2004,160.821z"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error.87d9963486a93eb89cce48a5e5dc3c2a.svg";